(function () {
  const cleanColor = (v) =>
    String(v || "")
      .replace(/^#\s*\d+\s*/i, "") // removes "#1 " or "# 1 "
      .trim();

  const normalizeKey = (v) =>
    String(v || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  function extractKey(klixColorKeyAttr) {
    // Take everything before "|" (preferred), otherwise before "-" as backup.
    const raw = String(klixColorKeyAttr || "");
    const part =
      raw.includes("|") ? raw.split("|")[0] :
      raw.includes(" - ") ? raw.split(" - ")[0] :
      raw;
    return normalizeKey(part);
  }

  function getSelectedColor(productInfoEl) {
    const firstFieldset = productInfoEl.querySelector("variant-selects fieldset");
    const checked = firstFieldset?.querySelector('input[type="radio"]:checked');
    if (checked?.value) return checked.value;

    const select = productInfoEl.querySelector('variant-selects select[name^="options["]');
    if (select?.value) return select.value;

    const shown = productInfoEl.querySelector("variant-selects [data-selected-value]");
    if (shown?.textContent) return shown.textContent.trim();

    return null;
  }

  function showAll(productInfoEl) {
    productInfoEl
      .querySelectorAll('media-gallery li[data-target], media-gallery li[data-media-id]')
      .forEach((li) => (li.style.display = ""));
  }

  function getThumbs(productInfoEl) {
    return Array.from(
      productInfoEl.querySelectorAll(
        'media-gallery li[data-target][data-klix-color-key][data-klix-media-type]'
      )
    );
  }

  function getSlides(productInfoEl) {
    return Array.from(
      productInfoEl.querySelectorAll(
        'media-gallery li[data-media-id][data-klix-color-key][data-klix-media-type]'
      )
    );
  }

  function isImage(li) {
    return li.getAttribute("data-klix-media-type") === "image";
  }

  function clickThumb(li) {
    const btn = li.querySelector("button") || li;
    btn?.click?.();
  }

  function apply(productInfoEl) {
    const selected = getSelectedColor(productInfoEl);
    if (!selected) return;

    const wanted = normalizeKey(cleanColor(selected)); // "#1 Black" -> "black"

    showAll(productInfoEl);

    const thumbs = getThumbs(productInfoEl);
    const slides = getSlides(productInfoEl);

    const thumbMatches = thumbs.filter((li) => extractKey(li.getAttribute("data-klix-color-key")) === wanted);
    const slideMatches = slides.filter((li) => extractKey(li.getAttribute("data-klix-color-key")) === wanted);

    // If no matches, do nothing (fail safe)
    if (!thumbMatches.length || !slideMatches.length) return;

    thumbs.forEach((li) => (li.style.display = thumbMatches.includes(li) ? "" : "none"));
    slides.forEach((li) => (li.style.display = slideMatches.includes(li) ? "" : "none"));

    const preferred = thumbMatches.find(isImage) || thumbMatches[0];
    if (preferred) clickThumb(preferred);
  }

  function init(productInfoEl) {
    if (!productInfoEl || productInfoEl.__klixInit) return;
    productInfoEl.__klixInit = true;

    setTimeout(() => apply(productInfoEl), 50);

    const variantSelects = productInfoEl.querySelector("variant-selects");
    if (!variantSelects) return;

    let t;
    const run = () => {
      clearTimeout(t);
      t = setTimeout(() => apply(productInfoEl), 30);
    };

    variantSelects.addEventListener("change", run);
    variantSelects.addEventListener("click", run);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-info").forEach(init);
  });

  document.addEventListener("shopify:section:load", (e) => {
    e.target?.querySelectorAll?.("product-info")?.forEach(init);
  });
})();
